package com.bikompanion.ui.home

/**
 * The map with one station's sheet open.
 *
 * Holds the identity rather than the station: the sheet must keep following the live counts, and a
 * link can name a station before its network has loaded.
 */
data class StationRoute(
    val target: StationFocusTarget,
) : HomeRoute
